import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { LoaderService } from "./loader.service";
import { StorageService } from "./storage.service";


declare const window;
@Injectable()



export class ApiTokenInterceptor implements HttpInterceptor {

    constructor(
      private storage: StorageService,
      public loader:LoaderService
    ) {
  
    }
  
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      const headers:any = {
        // 'Content-Type': 'application/json; charset=utf-8',
      };
      // headers = headers.set('Access-Control-Allow-Origin','*')
      //  headers['Access-Control-Allow-Headers'] = "X-Requested-With,content-type,Token";
      //  headers['Access-Control-Allow-Origin'] = "*";
      //  headers['Access-Control-Allow-Credentials'] = "true";
      headers['content-Type'] = 'application/json';
  
      if (this.storage.get('token')) {
        headers.Token = this.storage.get('token');
      }
  
  
      request = request.clone({
        setHeaders: headers
        // setHeaders: {
        //     Authorization: `Bearer ${this.storage.get('token')}`
        // }
      });
  
  
      // return next.handle(request);
  
  
      const started = Date.now();
      return next.handle(request).pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            // this.loader.show()
            const elapsed = Date.now() - started;
            // console.log(event.body)
            const body = event.body;
            if (body.status == 'failure') {
              if (body.message == 108) {
                alert('Token expired');
                // Swal.fire({
                //   icon: 'error',
                //   title: 'Login',
                //   text: 'Login Expired',
                // })
                localStorage.clear();
                window.setTimeout(function() { window.location = 'https://google.com'; }, 3000);
              }
            }
            // console.log(`Request for ${req.urlWithParams} took ${elapsed} ms.`);
          }
        }, error => {
          console.error('NICE ERROR', error);
          // this.loader.hide()
  
        })
      );
    }
  }
  